export default "__VITE_ASSET__BUOmgWLK__"